import type {
  ClientPersonReference,
  PagedModelClientPersonReference
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { InfiniteData } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import type { PagedRequest } from '@/features/api/helper/params';
import {
  getInitialPageParam,
  getNextPageParam,
  getPreviousPageParam
} from '@/features/api/helper/params';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetInfiniteGroupMembers = (groupId: string) => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineGroupApi();

  const select = useCallback(
    ({
      pages
    }: InfiniteData<
      PagedModelClientPersonReference,
      PagedRequest
    >): ClientPersonReference[] => pages.flatMap((page) => page.content ?? []),
    []
  );

  return useInfiniteQuery({
    queryKey: [API_CACHE_KEYS.GROUP_MEMBERS, groupId, 'infinite'],
    queryFn: ({ pageParam }) =>
      api.getAllMembersByGroupId({ groupId, ...pageParam }),
    select,
    initialPageParam: getInitialPageParam(),
    getNextPageParam,
    getPreviousPageParam,
    enabled: isAuthenticated
  });
};
